// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyLongResponse {
    static getAttributeTypeMap() {
        return PharmacyLongResponse.attributeTypeMap;
    }
}
PharmacyLongResponse.discriminator = undefined;
PharmacyLongResponse.additionalProperties = false;
PharmacyLongResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "number"
    },
];
//# sourceMappingURL=pharmacyLongResponse.js.map